import ru from "./ru";
import en from "./en";
import tm from "./tm";

const translations = {
  ru: { translation: ru },
  en: { translation: en },
  tm: { translation: tm },
};

export default translations;
